import axios from '@apis/spring-client';
import { useQuery, useMutation } from 'react-query';
import { GetBizCheckInfoData } from 'models/swagger-spring/data-contracts';

export const getBizCheckInfo = async (corpNumber: string): Promise<GetBizCheckInfoData> => {
  try {
    const response = await axios.get(`/api/biz/check-info`, {
      params: {
        corpNumber,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useGetBizCheckInfo = (corpNumber: string, enabled: boolean) => {
  return useQuery(['bizCheckInfo', corpNumber], () => getBizCheckInfo(corpNumber), {
    enabled,
  });
};

export const useGetBizCheckInfoMutation = () => {
  return useMutation((corpNumber: string) => getBizCheckInfo(corpNumber), {
    onError: (error) => {
      console.error('사업자 정보 조회 실패:', error)
    }
  })
}

export default useGetBizCheckInfo;
